/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import has from"../../../../../core/has.js";function e(){return!!has("enable-feature:objectAndLayerId-rendering")}export{e as olidEnabled};
